/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, role: NonNullable<unknown>, status: NonNullable<unknown> }} Team_Manager_User_Option_LabelInputs */

const en_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const fr_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const de_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const it_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const ru_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const es_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const zh_cn2_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const ja_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const hi_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

const pt_pt2_team_manager_user_option_label = /** @type {(inputs: Team_Manager_User_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | ${i?.role}${i?.status}`)
};

/**
* | output |
* | --- |
* | "{name} \| {role}{status}" |
*
* @param {Team_Manager_User_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_option_label = /** @type {((inputs: Team_Manager_User_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_option_label(inputs)
	if (locale === "de") return de_team_manager_user_option_label(inputs)
	if (locale === "it") return it_team_manager_user_option_label(inputs)
	if (locale === "ru") return ru_team_manager_user_option_label(inputs)
	if (locale === "es") return es_team_manager_user_option_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_option_label(inputs)
	if (locale === "ja") return ja_team_manager_user_option_label(inputs)
	if (locale === "hi") return hi_team_manager_user_option_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_option_label(inputs)
	return en_team_manager_user_option_label(inputs)
});